let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iFq6Z")).then(() => parcelRequire('8czsU'));